import { Submission } from '#models';

const submissions: Submission[] = [
  {
    id: 1,
    caseId: 'PR-194903',
    ownership: 'ALS',
    wellName: 'ASTRODOME 122WA',
    api14: '42329420310001',
    fot: 'ODESSA EAST',
    gaugerBeat: '4000016',
    sectionName: 'BR 12 CTB',
    daysInCurrentStep: 13,
    failureDate: '11/1/25',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
  {
    id: 2,
    caseId: 'PR-193903',
    ownership: 'ALS',
    wellName: 'YETI 55H',
    api14: '30025455350001',
    fot: 'COTTON DRAW',
    gaugerBeat: '9010001',
    sectionName: 'CTND SAT 15',
    daysInCurrentStep: 19,
    failureDate: '--',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
  {
    id: 3,
    caseId: 'PR-185916',
    ownership: 'ALS',
    wellName: 'MID AX 14HB',
    api14: '42329415350001',
    fot: 'ODESSA EAST',
    gaugerBeat: '4000021',
    sectionName: 'CMC AX CTB',
    daysInCurrentStep: 229,
    failureDate: '--',
    downtimeCode: '--',
    createDate: '12/1/25',
  },
  {
    id: 4,
    caseId: 'PR-184918',
    ownership: 'ALS',
    wellName: 'C SCHARB 0074LS',
    api14: '42329426130001',
    fot: 'ODESSA CENTRAL',
    gaugerBeat: '4000003',
    sectionName: 'BG 28 CTB',
    daysInCurrentStep: 229,
    failureDate: '12/1/25',
    downtimeCode: '--',
    createDate: '12/1/25',
  },
  {
    id: 5,
    caseId: 'PR-184917',
    ownership: 'ALS',
    wellName: 'ANTELOPE RIDGE3H',
    api14: '30025423180001',
    fot: 'HOBBS BASE',
    gaugerBeat: '6070001',
    sectionName: 'PRODIGAL SUN CTB',
    daysInCurrentStep: 229,
    failureDate: '12/1/25',
    downtimeCode: '--',
    createDate: '12/1/25',
  },
  {
    id: 6,
    caseId: 'PR-184916',
    ownership: 'ALS',
    wellName: 'CICADA UNIT 20H',
    api14: '30015454250001',
    fot: 'HAYHURST NM',
    gaugerBeat: '9030001',
    sectionName: 'HNMS35CTB',
    daysInCurrentStep: 229,
    failureDate: '12/1/25',
    downtimeCode: '--',
    createDate: '12/1/25',
  },
  {
    id: 7,
    caseId: 'PR-184913',
    ownership: 'ALS',
    wellName: 'BAILEYS 234H',
    api14: '30015499530001',
    fot: 'HAYHURST NM',
    gaugerBeat: '9030001',
    sectionName: 'HNM25BTB',
    daysInCurrentStep: 230,
    failureDate: '11/1/25',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
  {
    id: 8,
    caseId: 'PR-184911',
    ownership: 'ALS',
    wellName: 'BAILEYS 234H',
    api14: '30015499530001',
    fot: 'HAYHURST NM',
    gaugerBeat: '9030001',
    sectionName: 'HNM25BTB',
    daysInCurrentStep: 230,
    failureDate: '11/1/25',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
  {
    id: 9,
    caseId: 'PR-184910',
    ownership: 'ALS',
    wellName: 'BAILEYS 234H',
    api14: '30015499530001',
    fot: 'HAYHURST NM',
    gaugerBeat: '9030001',
    sectionName: 'HNM25BTB',
    daysInCurrentStep: 230,
    failureDate: '11/1/25',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
  {
    id: 10,
    caseId: 'PR-184909',
    ownership: 'ALS',
    wellName: 'ANADRKO F 2',
    api14: '30025465480001',
    fot: 'HOBBS BASE',
    gaugerBeat: '6070001',
    sectionName: 'HBS F CTB',
    daysInCurrentStep: 230,
    failureDate: '--',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
  {
    id: 11,
    caseId: 'PR-184908',
    ownership: 'ALS',
    wellName: 'HAYDEN 08-05 12WA',
    api14: '30015471230001',
    fot: 'HAYHURST TX',
    gaugerBeat: '9030001',
    sectionName: 'HNTX 08 CTB',
    daysInCurrentStep: 231,
    failureDate: '11/1/25',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
  {
    id: 12,
    caseId: 'PR-184907',
    ownership: 'ALS',
    wellName: 'COX 35 FEDERAL 2H',
    api14: '30025450020001',
    fot: 'HOBBS BASE',
    gaugerBeat: '6070001',
    sectionName: 'COX 35 CTB',
    daysInCurrentStep: 231,
    failureDate: '11/1/25',
    downtimeCode: '--',
    createDate: '11/1/25',
  },
];

export default submissions;
